<template>
    <div class="header_container">
        <router-link :to="{ name: 'home' }" class="logo">
            <img :src="logoImage" alt="">
        </router-link>
        <ul class="nav_items">
            <li v-for="(nav, index) in navList" :key="index" @click="goto(nav)"
            :class="activeId === nav.navigateId ? 'active' : ''">
                <a href="javascript:void(0)">{{isCn?nav.navigateCnName:nav.navigateEnName}}</a>
            </li>
        </ul>
        <div class="language_btns">
            <span :class="isCn? 'active': ''" v-on:click='changeLanguage("cn")'>中文</span>
            <span :class="isCn? '': 'active'" v-on:click='changeLanguage("en")'>EN</span>
        </div>
    </div>
</template>
<script>
import ajax from '@/utils/ajax';

export default {
    name: 'Header',
    props: {
        navActive: String,
        navId: [Number, String],
    },
    data() {
        return {
            navList: [],
            logoImage: '',
            activeId: -1,
            isCn: window.localStorage.getItem('show-lang') !== 'en',
        };
    },
    watch: {
        navActive() {
            this.renderActive();
        },
        navId() {
            this.renderActive();
        },
    },
    mounted() {
        if (window.history && window.history.pushState) {
            window.addEventListener('popstate', this.goBack, false);
        }
        ajax.get('/web/common/navigate_list.json', { id: 0 }).then((result) => {
            this.navList = result.data.sonNavigateList;
            this.renderActive();
        }).catch(() => {});
        ajax.get('/web/common/logo.json', { }).then((result) => {
            this.logoImage = result.data;
        }).catch(() => {});
    },
    destroyed() {
        window.removeEventListener('popstate', this.goBack, false);
    },
    methods: {
        goBack(e) {
            const lastPos = (e.state && e.state.navigatePos) || '';
            window.localStorage.setItem('ZBHA_NAV_POS', lastPos || '');
            this.renderActive();
        },
        changeLanguage(value) {
            if (value === 'cn') {
                this.isCn = true;
            } else {
                this.isCn = false;
            }
            window.localStorage.setItem('show-lang', value);
            document.location.reload();
        },
        renderActive() {
            const navigateUrl = this.$props.navActive || window.localStorage.getItem('ZBHA_NAV_ACTIVE') || '';
            const navigatePos = window.localStorage.getItem('ZBHA_NAV_POS') || '';
            this.navList.forEach((v) => {
                if (['home', 'about', 'corp'].indexOf(this.$props.navActive) > -1) {
                    if (this.$props.navActive === v.documentUrl) {
                        this.activeId = v.navigateId;
                    }
                } else if (navigatePos) {
                    if (+navigatePos === +v.position) {
                        this.activeId = v.navigateId;
                    }
                } else if (navigateUrl === v.documentUrl) {
                    this.activeId = v.navigateId;
                }
            });
        },
        goto(nav) {
            if (nav.documentUrl === 'home') {
                this.$router.push({ name: 'home' });
                this.$nextTick(() => {
                    window.localStorage.setItem('ZBHA_NAV_ACTIVE', nav.documentUrl);
                    window.localStorage.setItem('ZBHA_NAV_POS', nav.position || '');
                    this.renderActive();
                });
            } else {
                ajax.get('/web/common/navigate_list.json', { id: nav.navigateId }).then((result) => {
                    if (result.data.sonNavigateList.length === 0) {
                        return;
                    }
                    if (nav.systemFlag === 1) {
                        this.$router.push({ name: nav.documentUrl });
                    } else if (nav.documentUrl && !nav.documentId) {
                        this.$router.push({ name: nav.documentUrl, params: { id: nav.navigateId } });
                    } else {
                        this.$router.push({ name: 'customNav', params: { id: nav.navigateId } });
                    }
                    this.$nextTick(() => {
                        window.localStorage.setItem('ZBHA_NAV_ACTIVE', nav.documentUrl);
                        window.localStorage.setItem('ZBHA_NAV_POS', nav.position || '');
                        this.renderActive();
                    });
                }).catch(() => {});
            }
        },
    },
};
</script>

<style lang="less" scoped>
.header_container {
    width: 100%;
    height: 70px;
    background: #C71F4B;
    color:rgba(255,255,255,0.65);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}
.logo{
    float: left;
    position: absolute;
    left: 13px;
    top: 13px;
    img {
        width: 37px;
        height: 44px;
    }
}
@media only screen and (max-width: 1200px) {
    .logo {
        display: none;
    }
}
.nav_items{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 16px;
    font-weight:600;
    padding-right: 96px;
    padding-left: 300px;
    width: 100%;
    height: 100%;
    background: #C71F4B;
    li{
        margin-right: 48px;
        position: relative;
        white-space:nowrap;
        a{
            color:rgba(255,255,255,0.65);
        }
        a:hover{
            font-weight: bold;
            color: #fff;
        }
    }
    .active{
        a{
            color: #fff;
        }
        &:after{
            content: "";
            width: 25px;
            position: absolute;
            bottom:-8px;
            left:50%;
            margin-left: -12px;
            border-bottom:3px solid #fff;
        }
    }
}
.language_btns{
    width: 80px;
    height: 30px;
    background:rgba(255,255,255,0.25);
    line-height: 30px;
    text-align: center;
    font-size: 13px;
    font-family:PingFangSC-Regular;
    position: absolute;
    right: 20px;
    top: 20px;
    span{
        cursor: pointer;
        &:first-child{
            position: relative;
            margin-right: 4px;
            &:after{
                content: "";
                width: 2px;
                height: 13px;
                position: absolute;
                right:-4px;
                top:2px;
                margin-left: -12px;
                background:rgba(255,255,255,0.25);
            }
        }
        &:last-child{
            margin-left: 4px;
        }
    }
    .active{
        font-weight:400;
        color:rgba(47,140,220,1);
    }
}

</style>
